module.exports = __webpack_public_path__ + "img/testimonial-bg.26f4ccfc.jpg";